import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootState } from '@/redux/store'
import { MenuLinks } from '@/constants/menu'
import { PermissionTypes } from '@/constants/permissions'
import { usePermission } from '@/hooks/usePermission'
import type { ViewUserDetailsResponse } from '@/helpers/api/WebApiClient'

const shellCard = 'rounded-[1.2rem] border border-border bg-card shadow-[inset_0_1px_0_rgba(255,255,255,0.02)]'

/**
 * Landing page for the plain "User" role (Basic permission set). This role has no admin
 * permissions, so it doesn't get the tenant-admin or super-admin dashboards - but it should
 * still land somewhere useful instead of an indefinite loading skeleton.
 */
const BasicUserDashboard = () => {
	const { userHasPermission } = usePermission()
	const userData = useSelector((state: RootState) => state.Auth.userData) as ViewUserDetailsResponse | Record<string, never>
	const firstName = ('firstName' in userData && userData.firstName?.trim()) || ('userName' in userData && userData.userName?.split('@')[0]) || 'there'

	const links = [
		userHasPermission(PermissionTypes.Permissions_EmailLog_View) && {
			label: 'Activity Log',
			description: 'View recent email activity for your account.',
			url: MenuLinks.ManageEmailLog,
			icon: 'ri-pulse-line',
		},
		userHasPermission(PermissionTypes.Permissions_EmailTemplates_View) && {
			label: 'Email Templates',
			description: 'View and manage email templates.',
			url: MenuLinks.ManageEmailTemplate,
			icon: 'ri-mail-settings-line',
		},
		{
			label: 'Notifications',
			description: 'Check your latest notifications.',
			url: MenuLinks.Notifications,
			icon: 'ri-notification-3-line',
		},
	].filter(Boolean) as { label: string; description: string; url: string; icon: string }[]

	return (
		<div className="min-w-0 w-full py-4 text-foreground">
			<div className={`${shellCard} px-6 py-6`}>
				<h4 className="text-lg font-semibold">Welcome back, {firstName}</h4>
				<p className="mt-1 text-muted-foreground">
					Here's what you have access to. Contact your administrator if you need access to more.
				</p>
			</div>

			{/* <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
				{links.map((link) => (
					<Link key={link.url} to={link.url} className={`${shellCard} flex items-start gap-3 px-5 py-5 transition hover:border-primary/50`}>
						<i className={`${link.icon} text-2xl text-primary`} aria-hidden />
						<div>
							<div className="font-semibold">{link.label}</div>
							<div className="text-sm text-muted-foreground">{link.description}</div>
						</div>
					</Link>
				))}
			</div> */}
		</div>
	)
}

export default BasicUserDashboard
